import { useEffect } from 'react';
import { captureUTMParams } from '@/hooks/useUTMTracking';

/**
 * Component that captures UTM parameters on mount.
 * Place this near the root of your app to capture UTM params on every page load.
 */
export const UTMCapture = () => {
  useEffect(() => {
    captureUTMParams();
    const clear = () => { sessionStorage.removeItem('utm_params'); };
    window.addEventListener('consent_updated', clear);
    window.addEventListener('storage', clear);
    return () => { window.removeEventListener('consent_updated', clear); window.removeEventListener('storage', clear); };
  }, []);

  return null;
};

export default UTMCapture;
